import React, { useState, useEffect } from "react";
import { EditorState, RichUtils, convertToRaw, convertFromRaw } from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createInlineToolbarPlugin from "@draft-js-plugins/inline-toolbar";
import { ItalicButton, BoldButton, UnderlineButton } from "@draft-js-plugins/buttons";
import "draft-js/dist/Draft.css";
import "@draft-js-plugins/inline-toolbar/lib/plugin.css";
import Axios from 'axios';
import "./Report.css";
import { Host, host } from "../../App";

const inlineToolbarPlugin = createInlineToolbarPlugin();
const { InlineToolbar } = inlineToolbarPlugin;

const headings = [
  "Health & Safety",
  "Machine Update",
  "Equipment/ Maintenance Issues",
  "Task of the day",
  "Comments",
];

const New_ShiftReport = () => {
  const [editorStates, setEditorStates] = useState(() => headings.map(() => EditorState.createEmpty()));
  const [files, setFiles] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [shift, setShift] = useState("Morning");
  const supervisor = window.localStorage.getItem("Name")?.replace(/[{""}]/g, "") || "";
  const tokens = window.localStorage.getItem("acessToken");
  const [isLoading, setIsLoading] = useState(false);
  const [Status, setStatus] = useState("");
  const [availableTickets, setAvailableTickets] = useState([]);
  const [linkedTickets, setLinkedTickets] = useState([]);
  const [ticketFilter, setTicketFilter] = useState("open"); // 'open', 'in_progress', 'completed', 'closed', 'all'

  const queryParams = {
    date,
    shift,
    supervisor,
    token: tokens,
  };

  useEffect(() => {
    // In New_ShiftReport.js - Update the fetchAvailableTickets function
    const fetchAvailableTickets = async () => {
      try {
        const response = await Axios.get(`https://` + Host + `/maintenance/api/tickets/available`, {
          params: {
            token: tokens,
            maintainer: supervisor,
            status: ticketFilter // 'open', 'in_progress', 'completed', 'closed', 'all'
          }
        });
        if (response.data) {
          setAvailableTickets(response.data);
        }
      } catch (error) {
        console.error('Error fetching available tickets:', error);
        // Don't show alert, just set empty array
        setAvailableTickets([]);
      }
    };
    fetchAvailableTickets();
  }, [tokens, supervisor, ticketFilter]);

  const handleTicketToggle = (ticketId) => {
    setLinkedTickets(prev => {
      if (prev.includes(ticketId)) {
        return prev.filter(id => id !== ticketId);
      } else {
        return [...prev, ticketId];
      }
    });
  };

  useEffect(() => {
    Axios.get(`https://` + Host + `/maintenance/shiftdraft`, { params: queryParams }).then((data) => {
      if (data.data.length > 0) {
        const savedContent = data.data[0].Draft;

        if (savedContent) {
          try {
            const parsedContent = JSON.parse(savedContent);

            if (Array.isArray(parsedContent)) {
              const updatedEditorStates = headings.map((_, index) => {
                const rawContent = parsedContent[index];
                return rawContent ? EditorState.createWithContent(convertFromRaw(rawContent)) : EditorState.createEmpty();
              });
              setEditorStates(updatedEditorStates);
            } else {
              setEditorStates(headings.map(() => EditorState.createEmpty()));
            }
          } catch (error) {
            setEditorStates(headings.map(() => EditorState.createEmpty()));
          }
        } else {
          setEditorStates(headings.map(() => EditorState.createEmpty()));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Draft = () => {
    const content = editorStates.map((editorState) => convertToRaw(editorState.getCurrentContent()));
    const Content_modified = JSON.stringify(content);

    const formData = new FormData();
    formData.append("content", Content_modified);
    formData.append("date", date);
    formData.append("shift", shift);
    formData.append("supervisor", supervisor);
    formData.append("linked_tickets", JSON.stringify(linkedTickets));

    Axios
      .post(`https://` + Host + `/maintenance/save-draft`, formData)
      .catch((error) => {
        console.error('Error saving draft:', error);
      });
  };

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const clearAllSections = () => {
    setEditorStates(headings.map(() => EditorState.createEmpty()));
  };

  const clearSection = (index) => {
    const newEditorStates = [...editorStates];
    newEditorStates[index] = EditorState.createEmpty();
    setEditorStates(newEditorStates);
  };

  const handleSubmit = () => {
    setIsLoading(true);

    const draft_content = editorStates.map((editorState) => convertToRaw(editorState.getCurrentContent()));
    const Content_modified = JSON.stringify(draft_content);

    const content = editorStates.map((editorState, index) => ({
      heading: headings[index],
      content: convertToRaw(editorState.getCurrentContent()),
    }));

    const formData = new FormData();
    formData.append("content", JSON.stringify(content));
    formData.append("draft", Content_modified);
    formData.append("date", date);
    formData.append("shift", shift);
    formData.append("supervisor", supervisor);
    formData.append("linked_tickets", JSON.stringify(linkedTickets));

    // Only append files if there are any
    if (files && files.length > 0) {
      files.forEach((file) => formData.append("files", file));
    }

    console.log('📝 Submitting report:');
    console.log('📝 Files:', files.length);
    console.log('📝 FormData entries:');
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    // If NO files, send as regular JSON instead of FormData
    if (!files || files.length === 0) {
      console.log('📝 No files, sending as JSON...');
      Axios
        .post(`https://` + Host + `/maintenance/save-report-no-files`, {
          content: JSON.stringify(content),
          draft: Content_modified,
          date: date,
          shift: shift,
          supervisor: supervisor,
          linked_tickets: JSON.stringify(linkedTickets)
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          setIsLoading(false);
          console.log('✅ Report saved:', response.data);
          alert("Report saved successfully!");
          window.location.reload(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("❌ Error saving report:", error);
          alert(error.response?.data?.error || "Failed to save the report.");
        });
    } else {
      // With files - use FormData
      console.log('📝 With files, sending as FormData...');
      Axios
        .post(`https://` + Host + `/maintenance/save-report`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          setIsLoading(false);
          console.log('✅ Report saved:', response.data);
          alert("Report saved successfully!");
          window.location.reload(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("❌ Error saving report:", error);
          alert(error.response?.data?.error || "Failed to save the report.");
        });
    }
  };

  const handleEditorChange = (editorState, index) => {
    const newEditorStates = [...editorStates];
    newEditorStates[index] = editorState;
    setEditorStates(newEditorStates);
  };

  const handleKeyCommand = (command, index) => {
    const newState = RichUtils.handleKeyCommand(editorStates[index], command);
    if (newState) {
      handleEditorChange(newState, index);
      return "handled";
    }
    return "not-handled";
  };

  useEffect(() => {
    Axios.get(`https://` + Host + `/maintenance/get_ReportData`, { params: queryParams }).then((response) => {
      if (response.data && response.data[0] && response.data[0].Status === "Submitted") {
        setStatus("Submitted");
      } else {
        setStatus("draft");
      }
    });
  }, [date, shift, supervisor]);

  return (
    <div id="new-shift-report-block" className="nsr-wrap">
      <div id="new_shift_report_block" className="nsr-card">
        {/* Top Controls */}
        <div className="nsr-top">
          <div className="nsr-field">
            <label className="nsr-label">Date</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
              className="form-control form-rounded nsr-input"
            />
          </div>

          <div className="nsr-field nsr-hidden">
            <label className="nsr-label">Shift</label>
            <select
              value={shift}
              className="form-control form-rounded nsr-input"
              onChange={(e) => setShift(e.target.value)}
            >
              <option value="Morning">Morning</option>
              <option value="Evening">Evening</option>
            </select>
          </div>

          <button className="btn btn-primary form-rounded nsr-clearAll" onClick={clearAllSections}>
            Clear Report
          </button>
        </div>

        {/* Sections */}
        <div className="Shift_block nsr-sections">
          {headings.map((heading, index) => (
            <div key={index} className="nsr-section">
              <div className="nsr-sectionHead">
                <div id="new_shift-heading" className="nsr-headingText">
                  {heading}
                </div>

                <button
                  className="btn btn-secondary"
                  id="mobileView"
                  onClick={() => clearSection(index)}
                  type="button"
                >
                  Clear
                </button>
              </div>

              <div
                className="nsr-editorShell"
                onClick={() => document.querySelectorAll(".DraftEditor-root")[index]?.focus()}
              >
                <Editor
                  editorState={editorStates[index]}
                  onChange={(editorState) => handleEditorChange(editorState, index)}
                  handleKeyCommand={(command) => handleKeyCommand(command, index)}
                  plugins={[inlineToolbarPlugin]}
                  className="form-control form-rounded nsr-editor"
                  onBlur={Draft}
                  id={`shift_section_editor_${index}`}
                />

                <div className="nsr-toolbar">
                  <InlineToolbar>
                    {(externalProps) => (
                      <>
                        <BoldButton {...externalProps} />
                        <ItalicButton {...externalProps} />
                        <UnderlineButton {...externalProps} />
                      </>
                    )}
                  </InlineToolbar>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tickets Section */}
        <div className="nsr-tickets">
          <label className="nsr-label">Link Tickets</label>

          {/* Ticket Filter */}
          <div className="ticket-filter">
            <button
              className={`filter-btn ${ticketFilter === 'open' ? 'active' : ''}`}
              onClick={() => setTicketFilter('open')}
            >
              Open
            </button>
            <button
              className={`filter-btn ${ticketFilter === 'in_progress' ? 'active' : ''}`}
              onClick={() => setTicketFilter('in_progress')}
            >
              In Progress
            </button>
            <button
              className={`filter-btn ${ticketFilter === 'completed' ? 'active' : ''}`}
              onClick={() => setTicketFilter('completed')}
            >
              Completed
            </button>
            <button
              className={`filter-btn ${ticketFilter === 'closed' ? 'active' : ''}`}
              onClick={() => setTicketFilter('closed')}
            >
              Closed
            </button>
            <button
              className={`filter-btn ${ticketFilter === 'all' ? 'active' : ''}`}
              onClick={() => setTicketFilter('all')}
            >
              All
            </button>
          </div>

          {availableTickets.length === 0 ? (
            <p className="text-muted">No tickets available to link</p>
          ) : (
            <div className="ticket-select-list">
              {availableTickets.map(ticket => (
                <div key={ticket.id} className={`ticket-select-item ${ticket.status}`}>
                  <input
                    type="checkbox"
                    id={`ticket-${ticket.id}`}
                    checked={linkedTickets.includes(ticket.id)}
                    onChange={() => handleTicketToggle(ticket.id)}
                  />
                  <label htmlFor={`ticket-${ticket.id}`}>
                    <span className="ticket-number">#{ticket.ticket_number}</span>
                    <span className="ticket-desc">{ticket.issue_description}</span>
                    <span className={`ticket-priority ${ticket.priority?.toLowerCase()}`}>
                      {ticket.priority || 'Low'}
                    </span>
                    <span className={`ticket-status-badge ${ticket.status}`}>
                      {ticket.status?.replace(/_/g, ' ') || 'Unknown'}
                    </span>
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Attachments */}
        <div className="nsr-attach">
          <label className="nsr-label">Attachments (Optional)</label>
          <input
            type="file"
            className="form-control form-rounded nsr-input"
            multiple
            onChange={handleFileChange}
          />
          {files.length > 0 && (
            <div className="file-list">
              {files.map((file, index) => (
                <span key={index} className="file-name">
                  <i className="fas fa-file"></i> {file.name}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Submit */}
        <div className="nsr-submitRow">
          <button
            className="nsr-submitBtn"
            onClick={handleSubmit}
            disabled={Status === "Submitted" || isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Submitting...
              </>
            ) : Status === "Submitted" ? (
              "Already Submitted"
            ) : (
              "Submit Report"
            )}
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="overlay">
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default New_ShiftReport;